import { render, staticRenderFns } from "./TagRich.vue?vue&type=template&id=2ae9059b"
import script from "./TagRich.vue?vue&type=script&lang=js"
export * from "./TagRich.vue?vue&type=script&lang=js"
import style0 from "./TagRich.vue?vue&type=style&index=0&id=2ae9059b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports